/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleRectIcon20Solid = forwardRef('MoneyCurrencyRubleRectIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.2 7.2v2.6h1.775a1.3 1.3 0 0 0 0-2.6H9.2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm7.2 4h1.775a2.5 2.5 0 0 0 0-5H8.804A.804.804 0 0 0 8 6.804V9.8h-.4a.6.6 0 1 0 0 1.2H8v.8h-.4a.6.6 0 1 0 0 1.2H8v.625a.6.6 0 1 0 1.2 0V13h2.2a.6.6 0 1 0 0-1.2H9.2V11Z" })));
});
